import React from 'react';
import './InputGroup.scss';
import cl from 'classnames';

type InputGroupProps = {
    children: React.ReactNode,
    postfix?: React.ReactNode,
    className?: string
} & React.HTMLAttributes<HTMLDivElement>;

function InputGroup({
    children,
    postfix,
    className = '',
    ...rest
}: InputGroupProps ) {
    return (<div className={cl("ew-input-group", className)} {...rest}>
        <div className='ew-input-container'>
            {children}
        </div>
        {postfix}
    </div>);
}

InputGroup.HintText = ({ children, ignoreInputState = false }: { children: React.ReactNode, ignoreInputState?: boolean }) => {
    return <div className={ignoreInputState ? "ew-hint-text" : "ew-hint-text-with-input"}>{children}</div>
}
export default InputGroup;